// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KK8Rh","fullView":"styles_fullView__2RC-C"};